const FieldNames = {
    primaryPackagingDetails: {
        packageType: 'Package Type',
        category: 'Category',
        brand: 'Brand',
        application: 'Application',
        finishType: 'Finish Type',
        packageMaterial: 'Package Material',
        filledBottleTopLoad: 'Filled Bottle Top Load',
        diameter: 'Diameter',
        packageHeight: 'Package Height',
        netContent: 'Net Content',
        filledWeight: 'Filled Weight',
        bottleDesign: 'Bottle Design',
        canDesign: 'Can Design',
        diameterUnit: 'Diameter Unit',
        packageHeightUnit: 'Package Height Unit',
        netContentUnit: 'Net Content Unit',
        filledWeightUnit: 'Filled Weight Unit'
    },
    secondaryPackagingDetails: {
        secondaryPkg: 'Secondary Package',
        secondaryPackageType: 'Secondary Package Type',
        secondaryPackageCase: 'Items/Case',
        secondaryUnitNetWeight: 'Secondary Unit Net Weight',
        secondaryUnitGrossWeight: 'Secondary Unit Gross Weight',
        secondaryCaseLength: 'Secondary Case Length',
        secondaryCaseWidth: 'Secondary Case Width',
        secondaryCaseHeight: 'Secondary Case Height',
        filledCaseCompression: 'Filled Case Compression',
        secondaryUnitNetWeightUnit: 'Secondary Unit Net Weight Unit',
        secondaryUnitGrossWeightUnit: 'Secondary Unit Gross Weight Unit',
        secondaryCaseLengthUnit: 'Secondary Case Length Unit',
        secondaryCaseWidthUnit: 'Secondary Case Width Unit',
        secondaryCaseHeightUnit: 'Secondary Case Height Unit'
    },
    tertiaryPackagingDetails: {
        tertiaryPkg: 'Tertiary Package',
        tertiaryPackageType: 'Tertiary Package Type',
        tertiarySecondaryPackagesPerUnit: 'Tertiary Secondary Packages Per Unit',
        tertiaryUnitNetWeight: 'Tertiary Unit Net Weight',
        tertiaryUnitGrossWeight: 'Tertiary Unit Gross Weight',
        tertiaryCaseLength: 'Tertiary Case Length',
        tertiaryCaseWidth: 'Tertiary Case Width',
        tertiaryCaseHeight: 'Tertiary Case Height',
        tertiaryUnitNetWeightUnit: 'Tertiary Unit Net Weight Unit',
        tertiaryUnitGrossWeightUnit: 'Tertiary Unit Gross Weight Unit',
        tertiaryCaseLengthUnit: 'Tertiary Case Length Unit',
        tertiaryCaseWidthUnit: 'Tertiary Case Width Unit',
        tertiaryCaseHeightUnit: 'Tertiary Case Height Unit'
    },
    unitLoadDetails: {
        unitLoadLength: 'Unit Load Length',
        unitLoadWidth: 'Unit Load Width',
        unitLoadHeight: 'Unit Load Height',
        unitLoadWeight: 'Unit Load Weight',
        unitCasesPerLayer: 'Unit Cases Per Layer',
        unitLayersPerUnitLoad: 'Number of Layers',
        machineAssembled: 'Machine Assembled',
        plant: 'Plant',
        plantLine: 'Plant Line',
        newPlantLine: 'New Plant Line',
        engHelp: 'Engineering Help',
        varietyPack: 'Variety Pack',
        totalCasesPerUnitLoad: 'Total Cases Per Unit Load',
        itemsPerPallet: 'Items Per Pallet',
        palletPatternDesign: 'Pallet Pattern Design',
        unitLoadLengthUnit: 'Unit Load Length Unit',
        unitLoadWidthUnit: 'Unit Load Width Unit',
        unitLoadHeightUnit: 'Unit Load Height Unit',
        unitLoadWeightUnit: 'Unit Load Weight Unit'
    },
    palletDetails: {
        palletTypes: 'Pallet Types',
        palletMaterial: 'Pallet Material',
        palletLength: 'Pallet Length',
        palletWidth: 'Pallet Width',
        palletDepth: 'Pallet Depth',
        palletLengthUnit: 'Pallet Length Unit',
        palletWidthUnit: 'Pallet Width Unit',
        palletDepthUnit: 'Pallet Depth Unit'
    },
    palletizingRecipe: {
        stretchGa: 'Stretch GA',
        stretchWidth: 'Stretch Width',
        numberOfRevsTop: 'Number of Revs Top',
        numberOfRevsMiddle: 'Number of Revs Middle',
        numberOfRevsBottom: 'Number of Revs Bottom',
        cutAndWeigh: 'Cut and Weigh',
        preStretch: 'Pre Stretch',
        stretchWrapSpecNumber: 'Stretch Wrap Spec Number',
        stretchWidthUnit: 'Stretch Width Unit'
    },
    ftlDetails: {
        topMeasured: 'Top Measured (lbs)',
        middleMeasured: 'Middle Measured (lbs)',
        bottomMeasured: 'Bottom Measured (lbs)',
        notes: 'Notes',
        ftlState: 'FTL State (yes/no)',
        endStatusPallet: 'End Status',
        lpnNo: 'LPN Number'
    },
    leanDetails: {
        sideABottom: 'Side A Bottom (in)',
        sideATop: 'Side A Top (in)',
        sideALean: 'Side A Lean (in)',
        sideBBottom: 'Side B Bottom (in)',
        sideBTop: 'Side B Top (in)',
        sideBLean: 'Side B Lean (in)',
        sideCBottom: 'Side C Bottom (in)',
        sideCTop: 'Side C Top (in)',
        sideCLean: 'Side C Lean (in)',
        sideDBottom: 'Side D Bottom (in)',
        sideDTop: 'Side D Top (in)',
        sideDLean: 'Side D Lean (in)',
        endStatusPallet: 'End Status',
        lpnNo: 'LPN Number'
    },
    unitLoadPosition: {
        sideAPosition: 'Side A Position (inch)',
        sideBPosition: 'Side B Position (inch)',
        sideCPosition: 'Side C Position (inch)',
        sideDPosition: 'Side D Position (inch)',
        endStatusPallet: 'End Status',
        lpnNo: 'LPN Number'
    }
};

export default FieldNames;

